// ABOUTME: Filters the tabs of a custom page column down to those the user can see.
// ABOUTME: A tab is visible when at least one of its widgets passes the widget role check.

import { CustomPageTab } from '../types';
import { isWidgetVisibleForRoles } from '../widgets/utils/widgetRoles';

export function visibleTabs(
    tabs: CustomPageTab[],
    hasUserRole: (role: string) => boolean,
): CustomPageTab[] {
    return tabs.filter(tab =>
        tab.widgets.some(widget =>
            isWidgetVisibleForRoles(
                widget.config as Record<string, unknown> | null | undefined,
                hasUserRole,
            ),
        ),
    );
}
